import React from "react";

const VARIANTS = {
  primary:   "btn-pm--primary",
  secondary: "btn-pm--secondary",
  ghost:     "btn-pm--ghost",
  danger:    "btn-pm--danger",
  inverse:   "btn-pm--inverse",
};

const SIZES = {
  sm: "btn-pm--sm",
  md: "",
  lg: "btn-pm--lg",
};

const Button = React.forwardRef(({
  variant = "primary",
  size = "md",
  block = false,
  leftIcon,
  rightIcon,
  loading = false,
  disabled,
  className = "",
  type = "button",
  children,
  ...rest
}, ref) => {
  const cls = [
    "btn-pm",
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size],
    block && "btn-pm--block",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button ref={ref} type={type} className={cls} disabled={disabled || loading} {...rest}>
      {loading ? (
        <span className="spin" style={{ width: 14, height: 14, borderWidth: 2 }} />
      ) : (
        leftIcon
      )}
      {children}
      {!loading && rightIcon}
    </button>
  );
});

Button.displayName = "Button";
export default Button;
